const constants = {
    WIDGET_ICON_SIZE: '22px',
    NO_PROJECT_CONTRACT_ID: -1,
    MULTI_SELECT_MAX_ITEMS: 5,
    SECOND: 1000,
    MINUTE: 1000 * 60,
    DEFAULT_MODAL_WIDTH: 400,
    MAX_PROJECT_NAME_LENGTH: 50,
    MAX_SUB_PROGRAM_NAME_LENGTH: 50,
    formats: {
        date: {
            default: 'DD MMM YYYY',
            defaultForInput: 'DD/MM/YYYY',
            defaultWithTime: 'DD MMM YYYY HH:mm',
            yearMonthDay: 'YYYY-MM-DD',
            dayMonthYear: 'DD-MM-YYYY',
            fullDateWithMilliSeconds: 'MMMM Do YYYY, h:mm:ss a',
            versionDate: 'YYYY-MM-DD HH:mm:ss',
            fullMonthAndYear: 'MMMM YYYY',
            monthAndYear: 'MMM yyyy',
            weekAndMonth: 'DD MMM',
            fullYear: 'YYYY',
            fullMonth: 'MMM',
        },
    },
};

export default constants;
